import { render, staticRenderFns } from "./ControlPoint.vue?vue&type=template&id=8b1c9722&scoped=true&"
import script from "./ControlPoint.vue?vue&type=script&lang=js&"
export * from "./ControlPoint.vue?vue&type=script&lang=js&"
import style0 from "./ControlPoint.vue?vue&type=style&index=0&id=8b1c9722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1c9722",
  null
  
)

export default component.exports